<template>
  <div id="users">
    <div style="height: 3px;"></div>
    <div style="padding: 6px;"> </div>
    <div>
      <el-button class="btn btn1" icon="el-icon-circle-plus-outline" @click="addUser" :disabled="!addTableListPriv" :class="!addTableListPriv ? 'btnDisable' : ''">{{$t('message.button.add')}}
      </el-button>
      <el-button class="btn btn2" icon="el-icon-delete" @click="removeCheckbox" :disabled='!removeBtnPriv' :class="!removeBtnPriv ? 'btnDisable' : ''">{{$t('message.button.delete')}}
      </el-button>
    </div>

    <el-dialog class="searchAddBomList" v-if='addUserTable' :title="$t('message.title.add')" :visible.sync="addUserTable">
      <AddUser @listDbClick="addList"></AddUser>
    </el-dialog>

    <div style="padding: 10px 20px; height: 5%;">
      <vxe-grid v-bind="gridOptions" ref='xGrid' @cell-dblclick="userInfo">
        <template v-slot:operate="{ row }">
          <!-- <vxe-button icon="el-icon-view" :title="$t('message.button.check')" circle @click="userInfo(row)"></vxe-button> -->
          <vxe-button icon="el-icon-setting" :title="$t('message.transform.assignRoles')" @click="assignRoles({row})" circle></vxe-button>
        </template>
      </vxe-grid>
    </div>

    <!-- 分配角色对话框 -->
    <el-dialog center :title="$t('message.transform.assignRoles')" :visible.sync="assignDialogVisible" width="60%">
      <span>
        <template>
          <el-transfer filterable :titles=tableName v-model="assignedRoles" :data="allRoles"></el-transfer>
        </template>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="assignDialogVisible = false" class="el-icon-close">{{$t('message.button.cancel')}}</el-button>
        <el-button type="primary" @click="doAssignRoles" class="el-icon-check" :loading="btnLoading" :disabled="btnDisabled">{{$t('message.button.affirm')}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import AddUser from "@/components/addUser.vue";
import axios from "axios";
export default {
  data() {
    return {
      tableName: [],
      loading: true,
      assignDialogVisible: false,
      allRoles: [],
      assignedRoles: [],
      currentUserId: "",
      btnLoading: false,
      btnDisabled: false,
      loading: true,
      setObj: {},
      userList: [],

      addUserTable: false,

      gridOptions: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        height: "530",
        size: "small",
        columns: [],
        data: [],
        editConfig: {
          trigger: "manual",
          mode: "row",
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: false,
        },
        sortConfig: {
          trigger: "cell",
        },
      },
      tableShow: true, //显示table
      //查询对象
      queryMap: {
        pageNum: 1,
        pageSize: 6,
        username: "",
        sex: "",
        nickname: "",
      },
      userList: [],

      //权限
      removeBtnPriv: false,
      addTableListPriv: false,
    };
  },
  components: {
    AddUser,
  },
  methods: {
    checkUser(e) {
      console.log(e);
      this.userList = e.data;
    },
    addUser() {
      this.addUserTable = true;
    },
    removeUser() {
      console.log();
    },
    removeCheckbox(grid) {
      //删除
      let obj = {...this.$store.state.objectId};
      // obj.id = this.$store.state.objectId.id + "";
      // obj.classId = this.$store.state.objectId.classId + "";
      // obj.subClassId = this.$store.state.objectId.subClassId + "";
      console.log(this.$refs.xGrid);
      var removeRow = this.$refs.xGrid.getCheckboxRecords();
      console.log(removeRow);
      var del_table = [];
      var vm = this;
      if (removeRow.length == 0) {
        return false;
      } else {
        for (let i = 0; i < removeRow.length; i++) {
          const e = removeRow[i];
          del_table.push({
            id: e.itemId,
            classId: e.itemClassId,
          });
        }
        //console.log(del_table);
        var userList = {
          tableId: 92,
          userGroupObjId: obj,
          deleteUsers: del_table,
        };
        console.log(userList);
        axios
          .post("/pmdm/admin/userGroup/deleteTable", userList)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: "success",
              });
              //console.log(res);
              this.getUserList();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    addList(row) {
      //添加
      // console.log(this.gridOptions.data);
      
      let arr = this.gridOptions.data.map( i => i.itemId);
      if (!arr.includes(row.id)) {
        // this.addUserTable = false;
        let list = [];
        let insertUsers = {};
        insertUsers.id = row.id;
        insertUsers.classId = row.classId;
        list.push(insertUsers);
        let obj = {...this.$store.state.objectId};
      // obj.id = this.$store.state.objectId.id + "";
      // obj.classId = this.$store.state.objectId.classId + "";
      // obj.subClassId = this.$store.state.objectId.subClassId + "";
        var userList = {
          tableId: 92,
          userGroupObjId: obj,
          insertUsers: list,
        };
        console.log(userList);
        axios.post("/pmdm/admin/userGroup/saveTable", userList).then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getUserList();
            return;
          }
        });
      } else {
        this.$message.error(this.$t("message.error.sameUser"));
      }
    },
    // craeteUser() {
    //   this.$router.push("/createUser");
    // },
    userInfo(row) {
      //console.log(row);
      //this.$store.commit("setClassId", row.row.itemClassId);
      //this.$store.commit("setObjID", row.row.itemId);
      //this.$store.commit("setSubClassId", row.row.itemSubClassId);
      this.$router.push("/UserInfo");
    },
    searchEvent() {
      this.findList();
    },
    handlePageChange({ currentPage, pageSize }) {
      this.findList();
    },
    editRowEvent(row) {
      this.$refs.xGrid.setActiveRow(row);
    },
    saveRowEvent() {
      this.$refs.xGrid.clearActived().then(() => {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.$XModal.message({
            message: this.$t("message.success.save"),
            status: "success",
          });
        }, 300);
      });
    },
    removeRowEvent(row) {
      this.$XModal
        .confirm(this.$t("message.confirm.deleteData"))
        .then((type) => {
          if (type === "confirm") {
            this.$refs.xGrid.remove(row);
          }
        });
    },

    /**
     * 重置
     */
    reset() {
      this.queryMap = {
        pageNum: 1,
        pageSize: 6,
        username: "",
        sex: "",
        nickname: "",
      };
    },
    /**
     * 加载用户表格
     */
    downExcel() {
      var $this = this;
      // const res = axios
      //   .request({
      //     url: "/user/excel",
      //     method: "post",
      //     resType: "blob"
      //   })
      //   .then(res => {
      //     if (res.headers["content-type"] === "application/json") {
      //       return $this.$message.error(
      //         "Subject does not have permission [user:export]"
      //       );
      //     }
      //     const data = res.data;
      //     let url = window.URL.createObjectURL(data); // 将二进制文件转化为可访问的url
      //     var a = document.createElement("a");
      //     document.body.appendChild(a);
      //     a.href = url;
      //     a.download = "用户列表.xls";
      //     a.click();
      //     window.URL.revokeObjectURL(url);
      //   });
    },
    /**
     * 加载用户组列表
     */
    async getUserList() {
      let obj = {...this.$store.state.objectId};
      // obj.id = this.$store.state.objectId.id + "";
      // obj.classId = this.$store.state.objectId.classId + "";
      // obj.subClassId = this.$store.state.objectId.subClassId + "";
      obj.tableId = 92;
      console.log(obj);
      this.setObj = obj;
      console.log(this.setObj);

      const { data: res } = await this.$http.get(
        `/pmdm/admin/userGroup/loadTable${this.params(obj)}`
      );
      console.log(res);
      this.gridOptions.columns = this.getNewTableTitleData(res);
      this.gridOptions.columns.push({
        title: this.$t("message.table.actions"),
        width: 110,
        slots: {
          default: "operate",
        },
      });
      this.gridOptions.data = this.getNewTableContentData(res);
      //this.tableShow = true;
    },

    /**
     * 弹出用户分配角色
     */
    async assignRoles(row) {
      let obj = {};
      console.log(row);
      obj.id = row.row.itemId + "";
      obj.classId = row.row.itemClassId + "";
      obj.subClassId = row.row.itemSubClassId + "";
      //console.log(obj);
      this.setObj = obj;
      this.currentUserId = row.row.itemId;

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const { data: res } = await this.$http.get("/pmdm/admin/role/getAll");
      if (res.code == 200) {
        let arr = [];
        let roles = res.object.roles;
        roles.forEach((role) => {
          arr.push({
            key: role.id,
            label: role.name,
          });
        });
        this.allRoles = arr;
        console.log(this.allRoles);
      }

      const { data: res1 } = await this.$http.get(
        "/pmdm/admin/user/getRoles?id=" +
          obj.id +
          "&classId=" +
          obj.classId +
          "&subClassId=" +
          obj.subClassId
      );
      if (res1.code == 200) {
        let arr = [];
        let roles = res1.object.roles;
        roles.forEach((role) => {
          arr.push(role.id);
        });
        this.assignedRoles = arr;
        // console.log(this.assignedRoles);
      }

      setTimeout(() => {
        loading.close();
        this.assignDialogVisible = true;
      }, 400);
    },
    /**
     * 确定分配角色
     */
    async doAssignRoles() {
      this.assignDialogVisible = true;
      this.btnLoading = true;
      this.btnDisabled = true;
      // console.log(typeof(this.currentUserId) )
      // console.log(typeof(this.setObj.id) )
      // console.log(typeof(this.setObj.classId) )
      // console.log(typeof(this.setObj.subClassId) )

      //console.log(this.assignRoles);
      this.assignedRoles = this.assignedRoles.map((i) => {
        return i.toString();
      });
      const { data: res } = await this.$http.post(
        "/pmdm/admin/user/assignRoles",
        {
          id: this.setObj.id,
          classId: this.setObj.classId,
          subClassId: this.setObj.subClassId,
          assignedRoles: this.assignedRoles,
        }
      );
      if (res.code == 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.assignDialogVisible = false;
      this.btnLoading = false;
      this.btnDisabled = false;
      this.getUserList();
    },
    /**
     * 搜索用户
     */
    searchUser() {
      this.queryMap.pageNum = 1;
      this.getUserList();
    },
    loadUserPriv() {
      var priv_ = this.getUserContextPriv();
      // console.log(priv_);
      let subClass_Id = this.$store.state.objectId.subClassId;
      // console.log(subClass_Id);
      for (let i = 0; i < priv_.length; i++) {
        if (priv_[i].classId == subClass_Id) {
          // console.log(priv_[i]);
          if (priv_[i].type == 3) {
            this.addTableListPriv = true;
          }
          if (priv_[i].type == 4) {
            this.removeBtnPriv = true;
          }
        }
      }
    },
  },

  created() {
    this.tableName = [
      this.$t("message.transform.choices"),
      this.$t("message.transform.selected"),
    ];
    this.getUserList();
    this.loadUserPriv();
    setTimeout(() => {
      this.loading = false;
    }, 500);
  },
};
</script>